import { Link, useSearchParams } from 'react-router';
import { signInUrl } from '../api.js';
import { signOut, useMe } from '../hooks.js';

export function NotInvitedPage() {
  const [params] = useSearchParams();
  const app = params.get('app') ?? 'this app';
  const me = useMe();

  return (
    <div className="card centered">
      <h1>You haven't been invited to {app}</h1>
      <p>
        Ask the person who built it to add your Xero email address. Once they have, open the app's link again.
      </p>
      {me.data ? (
        <p className="small subtle">
          You're signed in as <strong>{me.data.email}</strong>. If that's not the address they used,{' '}
          <button type="button" className="btn btn-link" onClick={() => void signOut()}>
            sign out
          </button>{' '}
          and sign in with the right one.
        </p>
      ) : null}
      {!me.loading && !me.data ? (
        <p className="small subtle">
          <a href={signInUrl(`/not-invited?app=${encodeURIComponent(app)}`)}>Sign in</a> to see which address
          you're using.
        </p>
      ) : null}
      <p className="small">
        <Link to="/">Go to the console</Link>
      </p>
    </div>
  );
}
